import { React, useEffect, useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import AxiosInstance from "../../components/Axios";
import colors from "../../components/constants/Colors";
import Swal from "sweetalert2";

const DeleteIPR = () => {
  const project_id = localStorage.getItem("project_id");
  const { id } = useParams();

  const [myData, setMyData] = useState();
  const [loading, setLoading] = useState(true);

  /**Use the AxiosInstance to get the info from the backend by trying the URL of project, including the ID of the parameter*/
  // const GetData = () => {
  //   AxiosInstance.get(`ipr/${MyId}`).then((res) => {
  //     setMyData(res.data);
  //     console.log(res.data);
  //     setLoading(false);
  //   });
  // };

  // useEffect(() => {
  //   GetData();
  // }, []);

  const navigate = useNavigate();

  const submission = (data) => {
    AxiosInstance.delete(`projects/${project_id}/ipr/${id}/`)
      .then((res) => {
        navigate(`/monitoring`);
        Swal.fire("Success", "IPR deleted successfully!", "success");
      })
      .catch((error) => {
        Swal.fire(
          "Error",
          error.response?.data?.message || "Something went wrong!",
          "error"
        );
      });
  };

  return (
    <div>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
          backgroundColor: "#00003f",
          marginBottom: "10px",
        }}
      >
        <Typography sx={{ marginLeft: "20px", color: "#fff" }}>
          Delete line
        </Typography>
      </Box>

      <Box
        sx={{
          display: "flex",
          width: "100%",
          boxShadow: 3,
          padding: 4,
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "start",
            marginBottom: "40px",
          }}
        >
          Are you sure you want to delete this line ?
        </Box>

        <Box sx={{ width: "30%" }}>
          <Button
            variant="contained"
            onClick={submission}
            sx={{ width: "100%", backgroundColor: colors.secondary }}
          >
            Delete IPR
          </Button>
          <Button
            variant="contained"
            onClick={() => navigate("/")}
            sx={{ width: "100%", backgroundColor: colors.secondary, mt: 2 }}
          >
            Cancel
          </Button>
        </Box>
      </Box>
    </div>
  );
};

export default DeleteIPR;
